module.exports = __webpack_public_path__ + "media/img/foxbiz-5a8848de.jpg";